import React from "react";

import "./Header.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { openHelpPopup, openIncomeSettingsPopup } from "../../reducers/popupsReducer";
import { Widget } from "@typeform/embed-react";

import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  Link,
  DropdownItem,
  DropdownTrigger,
  Dropdown,
  DropdownMenu,
  Avatar,
  Button,
  Modal,
  ModalContent,
  ModalBody,
  useDisclosure,
} from "@nextui-org/react";

function Header(props) {
  const dispatch = useDispatch();
  const location = useLocation();

  // const [typeformPopupOpen, setTypeformPopupOpen] = useState(false);

  const userData = useSelector((state) => state.user.value);
  const { isOpen: typeformPopupOpen, onOpen: setTypeformPopupOpen, onOpenChange } = useDisclosure();

  // list of pages to navigate to
  const nav = [
    {
      text: "Dashboard",
      link: "/",
    },
  ];

  // add the /calculator page if the user is an employee
  if (userData.role === "employee") {
    nav.push({
      text: "Calculator",
      link: "/calculator",
    });
  }

  // add the /admin page if the user is an employee
  if (userData.role === "admin") {
    nav.push({
      text: "Admin",
      link: "/admin",
    });
  }

  return (
    <Navbar maxWidth="full">
      <NavbarBrand className="hover:cursor-pointer">
        <img className="w-[200px]" src="./logo-with-text.png" alt="Logo" />
      </NavbarBrand>

      <NavbarContent className="hidden sm:flex gap-4" justify="center">
        {/* {nav.map((link) => (
          <NavbarItem key={link.link} isActive={location.pathname === link.link}>
            <Link color="foreground" href={link.link}>
              {link.text}
            </Link>
          </NavbarItem>
        ))} */}
        {/* <NavbarItem>
          <Link color="foreground" href="#">
            Dashboard
          </Link>
        </NavbarItem>
        <NavbarItem isActive>
          <Link href="#" aria-current="page" color="secondary">
            Admin
          </Link>
        </NavbarItem> */}
      </NavbarContent>

      <NavbarContent as="div" justify="end">
        {/* {userData.role === "employee" && location.pathname === "/calculator" && (
          <NavbarItem className="hidden lg:flex">
            <Button
              as={Link}
              color="primary"
              href="#"
              variant="flat"
              onClick={() => dispatch(openIncomeSettingsPopup())}
            >
              Log your activity
            </Button>
          </NavbarItem>
        )} */}
        {userData.role === "employee" && location.pathname === "/calculator" && (
          <NavbarItem className="hidden lg:flex">
            <Button
              as={Link}
              color="primary"
              href="#"
              onClick={() => dispatch(openIncomeSettingsPopup())}
            >
              Income Settings
            </Button>
          </NavbarItem>
        )}
        <NavbarItem className="hidden lg:flex">
          <Button
            as={Link}
            color="primary"
            href="#"
            className="bg-[#002e62]"
            onClick={() => setTypeformPopupOpen(true)}
          >
            Log your activity
          </Button>
        </NavbarItem>
        <Dropdown placement="bottom-end">
          <DropdownTrigger>
            <Avatar
              isBordered
              as="button"
              className="transition-transform"
              color="secondary"
              name={userData.firstName.substring(0, 1) + userData.lastName.substring(0, 1)}
              src={`/avatars/${userData.firstName} ${userData.lastName}.jpg`}
              size="sm"
            />
          </DropdownTrigger>
          <DropdownMenu aria-label="Profile Actions" variant="flat">
            <DropdownItem key="profile" className="h-14 gap-2">
              <p className="font-semibold">{userData.firstName + " " + userData.lastName}</p>
              <p>{userData.email}</p>
            </DropdownItem>
            {nav.map((link) => (
              <DropdownItem key={link.link} href={link.link} color="danger">
                {link.text}
              </DropdownItem>
            ))}
            {/* <DropdownItem key="help" color="danger" onClick={() => dispatch(openHelpPopup())}>
              Help
            </DropdownItem> */}
            <DropdownItem key="logout" color="danger" onClick={() => props.signOut()}>
              Log Out
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Modal
          size="4xl"
          isOpen={typeformPopupOpen}
          onOpenChange={onOpenChange}
          closeButton={<></>}
        >
          <ModalContent>
            <ModalBody>
              <div style={{ height: "80vh" }}>
                <Widget
                  id={userData.role === "employee" ? "I5AvJ6ZH" : "Np1nU0uL"}
                  style={{ width: "100%", height: "100%" }}
                  className="my-form"
                />
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>
      </NavbarContent>
    </Navbar>
  );
}

export default Header;
